import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '@/permissions/project/permissions'

export enum ARCHIVE_PROJECT_PERMISSION {
  ARCHIVE_PROJECT = 'ARCHIVE_PROJECT',
}

export const getArchiveProjectPermissionsMatrix = (): Record<
  ARCHIVE_PROJECT_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => ({
  [ARCHIVE_PROJECT_PERMISSION.ARCHIVE_PROJECT]: {
    [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
    [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
    [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
  },
})
